<div class="alio-drawer">
  <header class="alio-drawer-header">
    <button
      mat-icon-button
      class="alio-history-btn"
      (click)="toggleHistory()"
      matTooltip="Chat history"
      matTooltipPosition="below"
      aria-label="Toggle chat history"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <div class="alio-drawer-title">
      <span class="alio-drawer-dot"></span>
      <span><strong>alio</strong> AI agent</span>
    </div>
  </header>

  <div class="alio-drawer-body">
    <dragonfly-chatbot></dragonfly-chatbot>

    @if (chatbot.loadingHistory$ | async) {
      <div class="alio-history-loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="32"
          color="primary"
        ></mat-progress-spinner>
      </div>
    }

    @if (historyOpen) {
      <div class="alio-history-backdrop" (click)="closeHistory()"></div>
    }

    <aside class="alio-history-panel" [class.alio-history-panel--open]="historyOpen">
      <div class="alio-history-header">
        <span>Chats</span>
        <button
          mat-icon-button
          class="alio-history-close"
          (click)="closeHistory()"
          aria-label="Close chat history"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <button type="button" class="alio-history-new" (click)="newChat()">
        <mat-icon>add</mat-icon>
        <span>New chat</span>
      </button>

      <div class="alio-history-list">
        @for (item of chatbot.conversationList$ | async; track item.threadId) {
          <div
            class="alio-history-item"
            [class.alio-history-item--active]="item.active"
            (click)="selectThread(item.threadId)"
          >
            <div class="alio-history-item-content">
              <span class="alio-history-item-title">{{ item.title || 'Untitled chat' }}</span>
              @if (item.preview) {
                <span class="alio-history-item-preview">{{ item.preview }}</span>
              }
            </div>
            @if (item.threadId !== generalThreadId) {
              <button
                mat-icon-button
                class="alio-history-remove"
                (click)="removeConversation(item.threadId, $event)"
                matTooltip="Remove from list"
                matTooltipPosition="below"
                aria-label="Remove chat from list"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
        }

        @if ((chatbot.pastSessionGroups$ | async)?.length) {
          <div class="alio-history-divider"></div>
        }

        @for (group of chatbot.pastSessionGroups$ | async; track group.label) {
          @for (session of group.sessions; track session.id) {
            <button type="button" class="alio-history-item" (click)="openPastSession(session)">
              @if (session.title) {
                <div class="alio-history-group-label">{{ session.title }}</div>
              } @else {
                <div class="alio-history-group-label">
                  {{ session.createdAt | date: 'MMM d, HH:mm' }}
                </div>
              }
            </button>
          }
        }

        @if (chatbot.loadingSessions$ | async) {
          <div class="alio-history-loading-row">
            <mat-progress-spinner
              mode="indeterminate"
              diameter="20"
              color="primary"
            ></mat-progress-spinner>
          </div>
        }
      </div>
    </aside>
  </div>
</div>
